import { MaskedField } from "@simplybusiness/mobius";
import { useLocale } from "../../../../../../../hooks/useLocale";
import type { QuestionComponentProps } from "../../types";
import { TextQuestion } from "../TextQuestion";

const TelephoneQuestionUS = (props: QuestionComponentProps) => {
  const { questionFieldProps } = props;
  const {
    value,
    validation,
    readOnly,
    onChange,
    onBlur,
    questionLabelProps,
    helpInfo,
    ...otherProps
  } = questionFieldProps;

  return (
    <MaskedField
      {...otherProps}
      onChange={onChange}
      onBlur={onBlur}
      mask={{ mask: "(000) 000-0000" }}
      isReadOnly={!!readOnly}
      defaultValue={value?.toString() || ""}
      useMaskedValue // Emit "(555) 123-4567"
      inputMode="tel"
    />
  );
};

export const TelephoneQuestion = (props: QuestionComponentProps) => {
  const { isUK } = useLocale();

  return isUK ? (
    <TextQuestion {...props} type="tel" />
  ) : (
    <TelephoneQuestionUS {...props} />
  );
};
